/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var sizeArray = require('../data/size'),
    gettext   = require('mag-gettext').gettext;


function saveValue ( value ) {
    top.gSTB.SetSubtitlesSize(value); //eslint-disable-line
}

module.exports = function ( app ) {
    return {
        id: 'subtitleSize',
        name: gettext('Subtitle size'),
        description: gettext('Setting the font size of subtitles'),
        icon: 'theme-icon-font-size',
        data: {
            subtitlesSize: 20
        },
        saveImmediate: true,
        prepareForRender: function ( currentValue, callback ) {
            sizeArray.forEach(function ( item ) {
                item.selected = item.value === currentValue.subtitlesSize;
            });

            callback(sizeArray);
        },
        prepareForSave: function ( value, callback ) {
            this.data.subtitlesSize = value;

            saveValue(value);
            callback();
        },
        render: app.api.renders.popupSelect,
        parent: 'playback'
    };
};

module.exports.setValue = saveValue;
